import { getScripbyTokenAndMktSegId, deleteWatchList, } from "../../apis";
import { convertColumnsDatatoGridColumns, convertScripResponseWatchlistGrid, convertTOVariable, deepClone, getApiExchangeNameFromMktSegId, getDecryptLocalStorage, getMappedMktSegIdFromApiExchangeName, handleUpdateWatchlistGrid, isGuestUser, setEncryptLocalStorage } from "../../utils/global_functions";
import { API_RESPONSE_STATUS, DEEP_LINK, DONT_MISS_WATCHLIST_NAME, LOCAL_STORAGE_KEYS, MANAGE_COLUMNS_VIEW_TYPES, MY_HOLDINGS_WATCHLIST_NAME, NETWORK_RESPONSE_STATUS, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { UPDATE_DEFAULT_MANAGE_COLUMN_NAME, WATCHLIST } from "../actionTypes";
import { getWhatsHotData, getWhatsHotDataSuccess, updateGroupedDontMissData } from "./dontMiss";
import { getHoldingsColumnDef, getHoldingsForWatchlist, updateHoldingsColdef, updateHoldingsScrips, updateWatchlistGridIndexHoldings } from "./holdings";
import { getWfhTouchlineLastTick } from './wfh';
import { _createWatchlist, _getScrips, _updateCurrentWatchlist, _updateWatchlistandSetDefault, _updatingWatchlist } from "../../controllers";
import { recommendation, topTenRecommendation } from "./recommendation";
import { updateDontMissData } from "../actions/dontMiss";
import { toastConfig } from "./toast";
import { createUserColumnProfiles, getDataByWatchlistId, scripAdditionalinfo } from "../../apis/nontransactional";
import { getNetPositionColumnDefs, getNetPositionColumnDefsSuccess } from "./netPosition";
import { getGtdColdefColumnDefs, getMultiLegOrderColumnDefs, getMultiLegOrderColumnDefsSuccess, getSingleScripOrderColumnDefs, getSingleScripOrderColumnDefsSuccess, getSipEquityOrderColumnDefs, getSipEquityOrderColumnDefsSuccess, getSpreadOrderColumnDefs, getSpreadOrderColumnDefsSuccess, updateGtdColdef } from "./orders";
import { _createUserColumnProfile, _deleteUserColumnProfile, _getUserColumnProfile, _updateUserColumnProfile } from "../../controllers/manageColumns";
import { handleModal } from "./modals";
import { getConstituentsColDef, getFutureColumnsdef, updateConstituentsColdef, updateFutureColdef } from "./marketOverview";
import { createIndexedDBStorage } from "../../apis/modals/indexdDB";


export const handleUpdateWatchlistWithTouchlineData = (objWatchlist, dispatch, objWatchlistScripIndexes) => {
    const objTouchlineData = dispatch(getWfhTouchlineLastTick());
    let arrScripsToBeUpdated = [];
    if (objWatchlist && objWatchlist?.scrips?.length > 0) {
        for (let i = 0; i < objWatchlist.scrips.length; i++) {
            if (objTouchlineData[objWatchlist.scrips[i][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]) {
                const arrScripToBeUpdated = handleUpdateWatchlistGrid(objTouchlineData[objWatchlist.scrips[i][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]], objWatchlist, objWatchlistScripIndexes);// Azeem K -05-07-2024 : Watchlist Optimization :Added objWatchlistScripIndexes
                arrScripsToBeUpdated.push(arrScripToBeUpdated);
            } else {
                arrScripsToBeUpdated.push(objWatchlist.scrips[i]);
            }
        }

    } else { }
    return arrScripsToBeUpdated;

};

//Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
export const updateColumnWiseColumns = (payload) => {
    return { type: WATCHLIST?.UPDATE_VIEW_WISE_COLUMN_PROFILES, payload };
};
//Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

//Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - Start
export const updateTenantColumnPorfiles = (payload) => {
    return { type: WATCHLIST?.UPDATE_TENANT_COLUMN_PROFILES, payload };
};
//Ameersha N : 23-10-2023 : BT-96552 - Breeze - Manage Columns  - End

export const isWatchlistUpdating = (payload) => {
    return { type: WATCHLIST.UPDATE_WATCHLIST_LOADING, payload };
};

export const getWatchLists = () => {
    return { type: WATCHLIST.GET_WATCHLIST, payload: {} };
};

export const updateIsWatchlistPresent = (payload) => {
    return { type: WATCHLIST.UPDATE_WATCHLIST_IS_PRESENT, payload };
};

export const getGlobalWatchlistScrips = (selectedGlobalWatchlist) => async (dispatch) => {
    // Get Scrips for global watchlist as per grid watchlist grid indexes
    // argument - entire watchlist object with scrips as array

    const arrSelectedGlobalWatchlist = await _getScrips(selectedGlobalWatchlist);
    if (arrSelectedGlobalWatchlist?.status) {
        dispatch(updateSelectedWatchlist(arrSelectedGlobalWatchlist?.data?.selectedGlobalWatchlistCopy));
    } else {

    }

};

export const updateSelectedWatchlist = (payload) => {
    return { type: WATCHLIST.UPDATE_SELECTED_WATCHLIST, payload };
};

//Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -Start
export const getHoldingsAndUpdateWatchlist = (isUpdateHoldingsWatchlist) => async (dispatch, getState) => {

    try {
        const dontMissData = getState()?.dontMiss?.dontMissData;
        const myHoldingWatchlist = await dispatch(getHoldingsForWatchlist());
        if (myHoldingWatchlist?.status === NETWORK_RESPONSE_STATUS.SUCCESS) { // if network call is success doing logic inside if part
            const watchlists = deepClone(getState().watchList?.watchlists) || [];
            const openWatchlists = deepClone(getState().watchList.openWatchlists);
            const activeWatchList = deepClone(getState().watchList.activeWatchList);
            const dashboardWatchlists = deepClone(getState().watchList.dashboardWatchlists);
            let nIndexInWatchlists = watchlists?.findIndex((eachWatchlist) => (eachWatchlist?.sWatchListName?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME));
            let nIndexInOpenWatchlists = openWatchlists?.findIndex((eachWatchlist) => (eachWatchlist?.sWatchListName?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME));

            if (myHoldingWatchlist?.data?.result?.length > 0) { // if network call is success and response data is greater than zero doing logic inside if part used to update holdings watchlist and return response on load also
                const arrHoldings = myHoldingWatchlist?.data?.result?.map((item) =>
                    ({ mkt: getApiExchangeNameFromMktSegId(item?.nMarketSegmentId), token: item?.nToken })
                );
                // see if i can reduce api call if holdings has scrips info

                const objScripsRes = await getScripbyTokenAndMktSegId(arrHoldings);
                const arrConvertedScripsOFHoldings = convertScripResponseWatchlistGrid(objScripsRes?.data?.result);
                //As mentioned in Story BT-95888 Create Watchlist Scrips of My Holdings Watchlist Need to be arrange in aplhabetical order
                const sortedHoldingScrips = arrConvertedScripsOFHoldings.sort((a, b) => a[WATCHLIST_GRID_INDEX.SYMBOL].localeCompare(b[WATCHLIST_GRID_INDEX.SYMBOL]));
                //Ameersha N - BT-95888 -Create Watchlist - 26-02-2024  --Start
                const newlySorted = sortedHoldingScrips?.map((each) => {
                    let aIndex = dontMissData?.findIndex(eachScrip => eachScrip[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN] === each[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]);
                    if (aIndex >= 0) {
                        return each = dontMissData[aIndex];
                    } else {
                        return each;
                    }
                });
                //Ameersha N - BT-95888 -Create Watchlist - 26-02-2024  --End
                dispatch(updateHoldingsScrips(myHoldingWatchlist?.data?.result));
                dispatch(updateWatchlistGridIndexHoldings(newlySorted));


                if (isUpdateHoldingsWatchlist) { // if result is grater than zero logic to update holdings scrips in watchlist 
                    const holdingsWatchlist = watchlists[nIndexInWatchlists];
                    holdingsWatchlist['scrips'] = newlySorted;

                    if (nIndexInWatchlists >= 0) {
                        watchlists[nIndexInWatchlists] = holdingsWatchlist;
                        dispatch(updateWatchListAction([...watchlists]));
                    }
                    if (nIndexInOpenWatchlists >= 0) {
                        openWatchlists[nIndexInOpenWatchlists] = holdingsWatchlist;
                        dispatch(updateOpenWatchlist([...openWatchlists]));
                    } else { }
                    if (Object?.keys(activeWatchList)?.length > 0 && activeWatchList?.id === holdingsWatchlist?.id) {
                        dispatch(updateActiveWatchlist({ ...holdingsWatchlist }));
                        if (dashboardWatchlists?.id === holdingsWatchlist.id) {
                            dispatch(updatedDashboardWatchlist({ ...holdingsWatchlist }));
                        } else { }
                    } else { }

                } else {

                }

                return Promise?.resolve(newlySorted);
            } else { // if network call is success and response data is less  than zero doing logic inside else part used to update holdings watchlist and return response on load also
                if (isUpdateHoldingsWatchlist) {
                    const holdingsWatchlist = watchlists[nIndexInWatchlists];
                    holdingsWatchlist['scrips'] = [];
                    if (nIndexInWatchlists >= 0) {
                        watchlists[nIndexInWatchlists] = holdingsWatchlist;
                        dispatch(updateWatchListAction([...watchlists]));
                    }
                    if (nIndexInOpenWatchlists >= 0) {
                        openWatchlists[nIndexInOpenWatchlists] = holdingsWatchlist;
                        dispatch(updateOpenWatchlist([...openWatchlists]));
                    } else { }
                    if (Object?.keys(activeWatchList)?.length > 0 && activeWatchList?.id === holdingsWatchlist?.id) {
                        dispatch(updateActiveWatchlist({ ...holdingsWatchlist }));
                    } else { }
                } else { }

                dispatch(updateHoldingsScrips(myHoldingWatchlist?.data?.result));
                dispatch(updateWatchlistGridIndexHoldings([]));
                return Promise?.resolve([]);
            }





        } else { // if network call is failied doing logic inside else part
            dispatch(updateHoldingsScrips([]));
            return [];
        }
    } catch (error) {
        return [];
    }
};
//Ameersha N -12-12-2023 - BREEZE - BT-95888 -Create Watchlist -End

export const updateWatchlistandDefault = (watchLists, column_profile) => async (dispatch, getState) => {
    dispatch(isWatchlistUpdating(true));// Azeem K : 30-04-2024 :added loader on watchlist screen
    try {
        const allowedNewsCat = getState()?.auth?.objLoginSession?.data?.others?.newsCategories;
        const objLoginSession = getState()?.auth?.objLoginSession;
        const watchlistTenantColumnProfiles = getState()?.watchList?.tenantColumnProfiles?.find(eachProfile => eachProfile?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.WATCHLIST_VIEW_TYPE?.toLowerCase() && eachProfile?.bIsDefault);
        const allColumnPRofiles = await dispatch(getUserColumnProfileAction(column_profile));
        // Filtering Columns porfiles of each view type - Start
        const { arrWatchlistColumnProfiles, objOrderSingleScripDefaultColumnProfile, objGtdDefaultColumnProfile,
            objMultiLegDefaultColumnProfile, objEquitySipDefaultColumnProfile, objSpreadDefaultColumnProfile,
            objNetPositionDefaultColumnProfile, objHoldingsDefaultColumnProfile, objConstituentsDefaultColumnProfile, objFutureDefaultColumnProfile } = allColumnPRofiles;

        // updating OrderSingleScrip columnProfile
        if (objOrderSingleScripDefaultColumnProfile && Object?.keys(objOrderSingleScripDefaultColumnProfile)?.length > 0 && objOrderSingleScripDefaultColumnProfile !== undefined) {

            let convetedColumDetails = objOrderSingleScripDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(getSingleScripOrderColumnDefsSuccess(convertedColumns));
        } else {
            dispatch(getSingleScripOrderColumnDefs());
        }

        // updating GtdScrip columnProfile
        if (objGtdDefaultColumnProfile && Object?.keys(objGtdDefaultColumnProfile)?.length > 0 && objGtdDefaultColumnProfile !== undefined) {

            let convetedColumDetails = objGtdDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(updateGtdColdef(convertedColumns));
        } else {
            dispatch(getGtdColdefColumnDefs());
        }


        // updating MultiLegScrip columnProfile
        if (objMultiLegDefaultColumnProfile && Object?.keys(objMultiLegDefaultColumnProfile)?.length > 0 && objMultiLegDefaultColumnProfile !== undefined) {
            let convetedColumDetails = objMultiLegDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(getMultiLegOrderColumnDefsSuccess(convertedColumns));
        } else {
            dispatch(getMultiLegOrderColumnDefs());
        }




        // updating equitySipScrip columnProfile
        if (objEquitySipDefaultColumnProfile && Object?.keys(objEquitySipDefaultColumnProfile)?.length > 0 && objEquitySipDefaultColumnProfile !== undefined) {
            let convetedColumDetails = objEquitySipDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(getSipEquityOrderColumnDefsSuccess(convertedColumns));
        } else {
            dispatch(getSipEquityOrderColumnDefs());
        }


        // updating SpreadScrip columnProfile
        if (objSpreadDefaultColumnProfile && Object?.keys(objSpreadDefaultColumnProfile)?.length > 0 && objSpreadDefaultColumnProfile !== undefined) {
            let convetedColumDetails = objSpreadDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(getSpreadOrderColumnDefsSuccess(convertedColumns));
        } else {
            dispatch(getSpreadOrderColumnDefs());
        }



        // updating netPosition columnProfile
        if (objNetPositionDefaultColumnProfile && Object?.keys(objNetPositionDefaultColumnProfile)?.length > 0 && objNetPositionDefaultColumnProfile !== undefined) {
            let convetedColumDetails = objNetPositionDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(getNetPositionColumnDefsSuccess(convertedColumns));
        } else {
            dispatch(getNetPositionColumnDefs());
        }
        // updating holdings columnProfile
        if (objHoldingsDefaultColumnProfile && Object?.keys(objHoldingsDefaultColumnProfile)?.length > 0 && objHoldingsDefaultColumnProfile !== undefined) {
            let convetedColumDetails = objHoldingsDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(updateHoldingsColdef(convertedColumns));
        } else {
            dispatch(getHoldingsColumnDef());
        }
        // updating constituents columnProfile
        if (objConstituentsDefaultColumnProfile && Object?.keys(objConstituentsDefaultColumnProfile)?.length > 0 && objConstituentsDefaultColumnProfile !== undefined) {
            let convetedColumDetails = objConstituentsDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(updateConstituentsColdef(convertedColumns));
        } else {
            dispatch(getConstituentsColDef());
        }
        // updating futures columnProfile
        if (objFutureDefaultColumnProfile && Object?.keys(objFutureDefaultColumnProfile)?.length > 0 && objFutureDefaultColumnProfile !== undefined) {
            let convetedColumDetails = objFutureDefaultColumnProfile?.columnDetails;
            convetedColumDetails?.forEach((eachProfile) => {
                eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
            });
            convetedColumDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
            });
            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
            dispatch(updateFutureColdef(convertedColumns));
        } else {
            dispatch(getFutureColumnsdef());
        }
        // Filtering Columns porfiles of each view type - End


        const nPage = 1;
        const nItems = -1;

        const arrRecommendationData = await dispatch(recommendation(allowedNewsCat, nPage, nItems));
        let arrSortedHoldingsScrips = [];
        if (!isGuestUser()) {
            arrSortedHoldingsScrips = await dispatch(getHoldingsAndUpdateWatchlist(false));
        } else {

        }
        let recommendationCopy = [];
        if (arrRecommendationData?.length > 0) {
            recommendationCopy = arrRecommendationData?.slice(0, 10);
        } else { }
        const objUpdateWatchlistandSetDefaultData = await _updateWatchlistandSetDefault(watchLists, recommendationCopy, arrSortedHoldingsScrips, objLoginSession);//holdingsWatchlist and dont miss also going inside
        if (objUpdateWatchlistandSetDefaultData?.data?.arrRecomendationScripWithIndexes?.length > 0) {
            dispatch(topTenRecommendation({ arrRecommendationScrips: objUpdateWatchlistandSetDefaultData?.data?.arrRecomendationScripWithIndexes, arrRecommendationInfo: recommendationCopy }));
        }
        dispatch(updateGroupedDontMissData(objUpdateWatchlistandSetDefaultData?.data?.arraAllDontMiss));
        dispatch(getWhatsHotDataSuccess(objUpdateWatchlistandSetDefaultData?.data?.whatsHotData));
        dispatch(updateDontMissData(objUpdateWatchlistandSetDefaultData?.data?.allDontMissScrips));
        const { objDefaultWatchlist, arrAllWatchlists, expiredScripsCount } = objUpdateWatchlistandSetDefaultData?.data;


        if (expiredScripsCount > 0) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `${expiredScripsCount} scrips expired !` }));
        } else { }

        if (arrAllWatchlists?.length > 0) {
            dispatch(updateWatchListAction([...arrAllWatchlists]));
        } else {
            dispatch(updateWatchListAction([]));
        }

        if (objDefaultWatchlist && Object.keys(objDefaultWatchlist).length > 0) {
            let columnId = JSON?.parse(objDefaultWatchlist?.sSettings);
            if (columnId?.columnPofileId) {
                let matchedColumnProfile = arrWatchlistColumnProfiles?.find((eachColum) => eachColum?.id === columnId?.columnPofileId);
                if (matchedColumnProfile) {
                    let convertedColumns = convertColumnsDatatoGridColumns(matchedColumnProfile?.columnDetails);
                    dispatch(columnDefSuccess(convertedColumns));
                } else {
                    let objMatchedColumnProfile = arrWatchlistColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
                    if (objMatchedColumnProfile) {
                        let convertedColumns = convertColumnsDatatoGridColumns(objMatchedColumnProfile?.columnDetails);
                        dispatch(columnDefSuccess(convertedColumns));
                    } else {
                        if (watchlistTenantColumnProfiles) {
                            let convetedColumDetails = watchlistTenantColumnProfiles?.columnDetails;
                            convetedColumDetails?.forEach((eachProfile) => {
                                eachProfile.sSettings = JSON?.parse(eachProfile?.sSettings);
                            });
                            convetedColumDetails?.forEach((eachColumn) => {
                                eachColumn.sSettings = { ...eachColumn?.sSettings, field: convertTOVariable(eachColumn?.sSettings?.field) };
                            });
                            let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
                            dispatch(columnDefSuccess(convertedColumns));
                        } else {
                            dispatch(getColumnDef());
                        }
                        // dispatch(getColumnDef());
                        // dispatch(columnDefFailure([])); // this hould be uncommented if not default columnProfile Exists from APi
                    }
                }
            } else {
                let objMatchedColumnProfile = arrWatchlistColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
                if (objMatchedColumnProfile) {
                    let convertedColumns = convertColumnsDatatoGridColumns(objMatchedColumnProfile?.columnDetails);
                    dispatch(columnDefSuccess(convertedColumns));
                } else {
                    if (watchlistTenantColumnProfiles) {
                        let convetedColumDetails = watchlistTenantColumnProfiles?.columnDetails;
                        convetedColumDetails?.forEach((eachProfile) => {
                            eachProfile.sSettings = typeof (eachProfile?.sSettings) === 'string' ? JSON?.parse(eachProfile?.sSettings) : eachProfile?.sSettings;
                        });
                        convetedColumDetails?.forEach((eachColumn) => {
                            eachColumn.sSettings = { ...eachColumn?.sSettings, field: typeof (eachColumn?.sSettings?.field) === 'string' ? convertTOVariable(eachColumn?.sSettings?.field) : eachColumn?.sSettings?.field };
                        });
                        let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);

                        dispatch(columnDefSuccess(convertedColumns));
                    } else {
                        dispatch(getColumnDef());
                    }
                    // dispatch(getColumnDef());
                    // dispatch(columnDefFailure([])); // this hould be uncommented if not default columnProfile Exists from APi
                }
            }
            //Ameersha N : BT-95888-Create Watchlist -Start
            //if null top line not null exctract all
            let activeWatchListID = localStorage?.getItem(LOCAL_STORAGE_KEYS.ACTIVE_WATCHLIST);
            let localStoredIds = JSON?.parse(localStorage?.getItem(LOCAL_STORAGE_KEYS.OPENED_WATCHLIST));
            if (localStoredIds && localStoredIds?.length > 0) {
                let arrFilteredWatchlists = arrAllWatchlists?.filter(eachWatchlist => localStoredIds?.includes(eachWatchlist?.id));
                if (arrFilteredWatchlists?.length > 0) {
                    dispatch(updateOpenWatchlist([...arrFilteredWatchlists]));
                } else if (arrFilteredWatchlists?.length === 0 && Object?.keys(objDefaultWatchlist)?.length > 0) {
                    dispatch(updateOpenWatchlist([objDefaultWatchlist]));
                }


                if (activeWatchListID) {
                    let activeWatchlistCopy = arrFilteredWatchlists?.find(eachWatchlist => eachWatchlist?.id === activeWatchListID);



                    if (activeWatchlistCopy && Object?.keys(activeWatchlistCopy)?.length > 0) {
                        dispatch(updateActiveWatchlist({ ...activeWatchlistCopy }));
                    } else {
                        dispatch(updateActiveWatchlist({ ...objDefaultWatchlist }));
                    }
                } else {
                    dispatch(updateActiveWatchlist({ ...objDefaultWatchlist }));
                }


            } else {
                dispatch(updateOpenWatchlist([objDefaultWatchlist]));
                dispatch(updateActiveWatchlist({ ...objDefaultWatchlist }));
            }
            //Ameersha N : BT-95888-Create Watchlist -End
            dispatch(updatedDashboardWatchlist({ ...objDefaultWatchlist }));
        }
        else {

            if (watchlistTenantColumnProfiles) {
                let convetedColumDetails = watchlistTenantColumnProfiles?.columnDetails;
                convetedColumDetails?.forEach((eachProfile) => {
                    eachProfile.sSettings = JSON?.parse(eachProfile?.sSettings);
                });
                convetedColumDetails?.forEach((eachColumn) => {
                    eachColumn.sSettings = { ...eachColumn?.sSettings, field: convertTOVariable(eachColumn?.sSettings?.field) };
                });
                let convertedColumns = convertColumnsDatatoGridColumns(convetedColumDetails);
                dispatch(columnDefSuccess(convertedColumns));
            } else {
                dispatch(getColumnDef());
            }

        }

        dispatch(updateGuestLoginIsLoading(false));
        return Promise.resolve();
    } catch (error) {
        console.error(error);
        dispatch(updateWatchListAction([]));
        dispatch(updateOpenWatchlist([]));
        dispatch(updateActiveWatchlist({}));
        dispatch(updateGuestLoginIsLoading(false));
    } finally {
        dispatch(isWatchlistUpdating(false));// Azeem K : 30-04-2024 :added loader on watchlist screen
    }

};

export const addNewWatchlist = (selectedWatchlist) => async (dispatch, getState) => {
    try {
        // selectedWatchlist from API in argument
        const watchlists = deepClone(getState().watchList?.watchlists) || [];
        const openWatchlists = deepClone(getState().watchList.openWatchlists);
        const objWatchlist = await _createWatchlist(selectedWatchlist);
        if (objWatchlist?.status) {
            const { objWatchlistResp } = objWatchlist?.data;
            const [allDontMissScrips, arrWatchlistRespAfterDontMiss] = await dispatch(getWhatsHotData([...watchlists, objWatchlistResp]));

            if (arrWatchlistRespAfterDontMiss?.length > 0) {

                const nIndex = arrWatchlistRespAfterDontMiss?.findIndex((watchlist) => watchlist?.sWatchListName?.toLowerCase() === DONT_MISS_WATCHLIST_NAME);
                if (nIndex >= 0) {
                    arrWatchlistRespAfterDontMiss[nIndex].scrips = allDontMissScrips;
                } else { }

                dispatch(updateWatchListAction([...arrWatchlistRespAfterDontMiss]));
                dispatch(updateOpenWatchlist([...openWatchlists, arrWatchlistRespAfterDontMiss[arrWatchlistRespAfterDontMiss?.length - 1]]));
                dispatch(updateActiveWatchlist(arrWatchlistRespAfterDontMiss[arrWatchlistRespAfterDontMiss?.length - 1]));
                return Promise.resolve(objWatchlist?.data?.objResp);
            } else { }
        }

    } catch (error) {
        if (error instanceof Error) {
            console.error(error.message);
        }
    }
};


export const updateCurrentWatchlist = (selectedWatchlist, isUpdateActiveWatchlist = true) => async (dispatch, getState) => {
    try {


        const openWatchlists = deepClone(getState().watchList.openWatchlists);

        const arrWatchlist = deepClone(getState().watchList.watchlists);
        const objOpenWatchlists = deepClone(getState().watchList.openWatchlists);


        const updateCurrentWatchlistResp = await _updateCurrentWatchlist(selectedWatchlist, arrWatchlist, objOpenWatchlists);

        const { nWatchlistsIndex, watchlists, nOpenWatchlistsIndex, ndontMissOpenWatchlistIndex, objWatchlistResp, objResp } = updateCurrentWatchlistResp?.data;
        //Empty dontmiss scrips and recreate again for delete and add scrips

        if (nWatchlistsIndex >= 0) {
            watchlists[nWatchlistsIndex] = objWatchlistResp;

            let allDontMissScrips = [];
            let arrWatchlistRespAfterDontMiss = [];
            let sortedDontMissScrips = [];
            try {
                const objDontMissResp = await dispatch(getWhatsHotData(watchlists));

                if (objDontMissResp?.length > 0) {
                    allDontMissScrips = objDontMissResp[0];
                    arrWatchlistRespAfterDontMiss = objDontMissResp[1];
                } else { }
            } catch (error) {
                allDontMissScrips = [];
                arrWatchlistRespAfterDontMiss = [];
                sortedDontMissScrips = error;
            }

            const nIndex = arrWatchlistRespAfterDontMiss?.findIndex(watchlist => watchlist?.sWatchListName?.toLowerCase() === DONT_MISS_WATCHLIST_NAME);
            if (nIndex >= 0) {
                arrWatchlistRespAfterDontMiss[nIndex].scrips = allDontMissScrips;
            } else { }
            const aIndex = arrWatchlistRespAfterDontMiss?.findIndex(watchlist => watchlist?.sWatchListName?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME);
            if (aIndex >= 0) {
                let arrHoldingsScrips = deepClone(getState()?.holdings?.watchlistGridIndexConvertedHoldingsScrips);
                arrWatchlistRespAfterDontMiss[aIndex].scrips = arrHoldingsScrips; // converted holdings scrips be assisned here;
            } else { }

            dispatch(updateWatchListAction([...arrWatchlistRespAfterDontMiss]));

            if (nOpenWatchlistsIndex >= 0) {
                openWatchlists[nOpenWatchlistsIndex] = arrWatchlistRespAfterDontMiss[nWatchlistsIndex];
                if (ndontMissOpenWatchlistIndex >= 0) {
                    openWatchlists[ndontMissOpenWatchlistIndex] = arrWatchlistRespAfterDontMiss[nIndex];
                } else { }


                dispatch(updateOpenWatchlist([...openWatchlists])).then(() => {
                    if (isUpdateActiveWatchlist) {
                        // const arrUpdatedWatchlistRespAfterDontMiss = handleActiveWatchlistUpdate(arrWatchlistRespAfterDontMiss[nWatchlistsIndex])
                        // arrWatchlistRespAfterDontMiss[nWatchlistsIndex].scrips = arrUpdatedWatchlistRespAfterDontMiss
                        dispatch(updateActiveWatchlist({ ...arrWatchlistRespAfterDontMiss[nWatchlistsIndex] }));
                    } else { }
                });

            } else { }
        } else { }
        //Ameersha N : Breeze BT-95888 Create watchlist feature -- 06-11-2023 --Start
        // returning the updated watchlist resp from api which helps with latest version avoiding version indifferences
        return Promise.resolve({ objResp, objWatchlistResp });
        //Ameersha N : Breeze BT-95888 Create watchlist feature -- 06-11-2023 --End
    } catch (error) {
        console.error(error.message);
        return Promise.reject(error);
    }
};


export const deleteWatchlistAction = (watchlist) => async (dispatch, getState) => {
    if (!isGuestUser()) {// is not variable its a function that need to be called 
        const objRes = await deleteWatchList({ strId: watchlist?.id, strVersion: watchlist?._version });
        if (objRes?.data?.status === API_RESPONSE_STATUS.SUCCESS) {
            let arrWatchlists = deepClone(getState().watchList.watchlists);
            let arrOpenWatchlists = deepClone(getState().watchList.openWatchlists);
            let objActiveWatchList = deepClone(getState().watchList.activeWatchList);
            const updateWatchlistResp = _updatingWatchlist(watchlist, arrWatchlists, arrOpenWatchlists, objActiveWatchList);
            dispatch(updateWatchListAction([...updateWatchlistResp?.data?.arrWatchlists]));
            dispatch(updateOpenWatchlist([...updateWatchlistResp?.data?.arrOpenWatchlists]));
            dispatch(updateActiveWatchlist({ ...updateWatchlistResp?.data?.objActiveWatchList }));
        } else { }
        return objRes;
    } else {
        const storedWatchlist = JSON.parse(getDecryptLocalStorage('GUEST_WATCHLIST'));
        const updateWatchlist = storedWatchlist?.filter(item => item?.id !== watchlist?.id);
        setEncryptLocalStorage('GUEST_WATCHLIST', JSON.stringify(updateWatchlist));
        let arrWatchlists = deepClone(getState().watchList.watchlists);
        let arrOpenWatchlists = deepClone(getState().watchList.openWatchlists);
        let objActiveWatchList = deepClone(getState().watchList.activeWatchList);
        const updateWatchlistResp = _updatingWatchlist(watchlist, arrWatchlists, arrOpenWatchlists, objActiveWatchList);
        dispatch(updateWatchListAction([...updateWatchlistResp?.data?.arrWatchlists]));
        dispatch(updateOpenWatchlist([...updateWatchlistResp?.data?.arrOpenWatchlists]));
        dispatch(updateActiveWatchlist({ ...updateWatchlistResp?.data?.objActiveWatchList }));
        return { data: { status: 'success', result: updateWatchlistResp } };
    }
};


export const updateGlobalWatchlist = (payload) => {
    return { type: WATCHLIST.UPDATE_GLOBAL_WATCHLIST, payload };
};

export const updateWatchListAction = (payload) => {
    return { type: WATCHLIST.UPDATE_WATCHLISTS, payload: payload };
};
export const updateWatchListInfoArr = (payload) => {
    return { type: WATCHLIST.UPDATE_WATCHLISTS_INFO, payload: payload };
};

export const updateOpenWatchlist = (payload) => (dispatch) => {
    dispatch({ type: WATCHLIST.UPDATE_OPEN_WATCHLIST, payload });
    return Promise?.resolve();

};


export const updateActiveWatchlist = (payload = { scrips: [] }) => (dispatch) => {
    // Azeem K -05-07-2024 : Watchlist Optimization --Start
    const objWatchlistScripIndexes = {};
    payload?.scrips?.forEach((scrip, index) => {
        objWatchlistScripIndexes[scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]] = index;
    });
    dispatch({ type: WATCHLIST.WATCHLIST_SCRIP_INDEXES, payload: objWatchlistScripIndexes });

    const arrActiveWatchlistScrips = handleUpdateWatchlistWithTouchlineData(payload, dispatch, objWatchlistScripIndexes);
    // Azeem K -05-07-2024 : Watchlist Optimization --End

    payload.scrips = arrActiveWatchlistScrips;

    return dispatch({ type: WATCHLIST.UPDATE_ACTIVE_WATCHLIST, payload });
};


export const getColumnDef = () => async (dispatch, getState) => {
    try {
        const objViewWiseColumnProfiles = getState().watchList.objViewWiseColumnProfiles;
        let settings = {};
        const updatedColumnDetails = objViewWiseColumnProfiles[MANAGE_COLUMNS_VIEW_TYPES.WATCHLIST_VIEW_TYPE]?.map((eachProfile) => {
            if (typeof eachProfile.sSettings === 'string') {
                settings = JSON?.parse(eachProfile?.sSettings);
            } else {
                settings = { ...eachProfile?.sSettings };
            }
            eachProfile.sSettings = { ...settings, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
            return eachProfile;
        });
        const arrdDefaultColumns = updatedColumnDetails?.filter(eachColumn => eachColumn?.sSettings?.bIsFixed === "true" || eachColumn?.sSettings?.bIsDefault === "true");
        dispatch(columnDefSuccess(convertColumnsDatatoGridColumns(arrdDefaultColumns)));
    } catch (error) {
        dispatch(columnDefFailure([]));
    }
};
export const columnDefSuccess = (objResp) => {
    return { type: WATCHLIST.GET_COLUMNDEF_SUCCESS, payload: objResp };
};

export const columnDefFailure = (payload) => {
    return { type: WATCHLIST.GET_COLUMNDEF_FAILURE, payload };
};
export const updateGuestLoginIsLoading = (payload) => {
    return { type: WATCHLIST.UPDATE_GUEST_IS_LOADING, payload: payload };
};

export const getUserColumnProfileAction = (column_profile) => async (dispatch) => {
    const controllerResp = _getUserColumnProfile(column_profile);
    if (controllerResp?.status) {
        dispatch(updateIsColumnPresent(true));
        dispatch(updateUserColumnDef(controllerResp?.data?.arrColumnProfiles));
        return controllerResp?.data;
    } else {
        dispatch(updateIsColumnPresent(false));
        return [];
    }
};


export const updateUserColumnProfileAction = (payload, isUpdateCurrentWatchlist = false, isUpdateCurrenGrid = false) => async (dispatch, getState) => {
    let selectedProfile = payload?.columnDetails?.map((eachColumn) => {
        if (typeof eachColumn.sSettings === 'string') {
            return eachColumn;
        } else {
            return { ...eachColumn, sSettings: JSON?.stringify(eachColumn?.sSettings) };
        }
    });
    let arrColumnProfiles = deepClone(getState().watchList.userColumnProfiles);
    let activeWatchlistCopy = deepClone(getState().watchList.activeWatchList);
    const controllerResp = await _updateUserColumnProfile({ ...payload, columnDetails: selectedProfile }, arrColumnProfiles, activeWatchlistCopy, isUpdateCurrentWatchlist);
    if (controllerResp?.status) {
        dispatch(updateUserColumnDef(controllerResp?.data?.arrColumnProfiles));
        dispatch(updateRespectiveColumnProfileBasedOnViewType(controllerResp?.data?.objRespProfile?.sViewType, controllerResp?.data?.objRespProfile));
        if (isUpdateCurrentWatchlist) {
            dispatch(updateCurrentWatchlist(controllerResp?.data?.finalActiveWatchlist, true));
            dispatch(updateStrViewType(''));
            return Promise?.resolve(controllerResp?.data?.objResp);
        } else {
            return Promise?.resolve(controllerResp?.data?.objResp);
        }
    } else {
        return Promise?.reject(controllerResp);
    }

};


export const deleteUserColumnProfileAction = (payload) => async (dispatch, getState) => {
    let arrColumnProfiles = deepClone(getState().watchList.userColumnProfiles);
    const controllerResp = await _deleteUserColumnProfile(arrColumnProfiles, payload);
    if (controllerResp) {
        dispatch(updateUserColumnDef(controllerResp?.data?.arrColumnProfiles));
        return Promise?.resolve(controllerResp?.data?.objResp);
    } else {
        return Promise?.reject(controllerResp?.data?.objResp);
    }
};





export const createUserColumnProfileAction = (payload, isUpdateCurrentWatchlist = false) => async (dispatch, getState) => {
    const objResp = await createUserColumnProfiles(payload);
    let activeWatchlistCopy = deepClone(getState().watchList.activeWatchList);
    const columnViewType = deepClone(getState()?.watchList?.columnViewType);

    if (objResp?.data?.status === API_RESPONSE_STATUS.SUCCESS) {
        let arrColumnProfiles = deepClone(getState().watchList.userColumnProfiles);
        let controllerResp = _createUserColumnProfile(objResp, arrColumnProfiles, activeWatchlistCopy, isUpdateCurrentWatchlist);
        if (controllerResp?.status) {
            dispatch(updateRespectiveColumnProfileBasedOnViewType(columnViewType, controllerResp?.data?.createdProfileResp));
            dispatch(updateUserColumnDef(controllerResp?.data?.arrColumnProfiles));
            // if viewtype is WATCHLIST VIEW TYPE then only we update Watchlist
            if (isUpdateCurrentWatchlist) {
                dispatch(updateCurrentWatchlist(controllerResp?.data?.finalActiveWatchlist, true));
            } else { }
        } else { }
        dispatch(updateStrViewType(''));
        return Promise?.resolve(objResp);
    } else {
        dispatch(updateStrViewType(''));
        return Promise?.reject(objResp);
    }
};

export const updateRespectiveColumnProfileBasedOnViewType = (columnViewType, objColumnProfile) => (dispatch, getState) => {
    let convertedColumns = [];
    switch (columnViewType) {
        case MANAGE_COLUMNS_VIEW_TYPES?.WATCHLIST_VIEW_TYPE:
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(columnDefSuccess(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SINGLE_SCRIP_VIEW_TYPE:
            // updating OrderSingleScrip columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(getSingleScripOrderColumnDefsSuccess(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_GOOD_TILL_DATE_VIEW_TYPE:
            // updating GtdScrip columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(updateGtdColdef(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_EQUITY_SIP_VIEW_TYPE:
            // updating equitySipScrip columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(getSipEquityOrderColumnDefsSuccess(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SPREAD_VIEW_TYPE:
            // updating SpreadScrip columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(getSpreadOrderColumnDefsSuccess(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.ORDER_MULTI_LEG_VIEW_TYPE:
            // updating MultiLegScrip columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(getMultiLegOrderColumnDefsSuccess(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.NET_POSITION_VIEW_TYPE:
            // updating netPosition columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(getNetPositionColumnDefsSuccess(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.HOLDINGS_VIEW_TYPE:
            // updating holdings columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(updateHoldingsColdef(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.CONSTITUENTS_VIEW_TYPE:
            // updating constituents columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(updateConstituentsColdef(convertedColumns));
            break;
        case MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE:
            // updating futures columnProfile
            convertedColumns = convertColumnsDatatoGridColumns(objColumnProfile?.columnDetails);
            dispatch(updateFutureColdef(convertedColumns));
            break;
        default:
            break;
    }





    // Filtering Columns porfiles of each view type - End

};


export const updateglobalColumnDef = (payload) => {
    return { type: WATCHLIST?.UPDATE_GLOBAL_COLUMN_PROFILES, payload };
};

export const updateUserColumnDef = (payload) => {
    return { type: WATCHLIST?.UPDATE_USER_COLUMN_PROFILES, payload };
};


export const updateIsColumnPresent = (payload) => {
    return { type: WATCHLIST?.UPDATE_IS_COLUMN_PRESENT, payload };
};

export const updateStrViewType = (payload) => {
    return { type: WATCHLIST?.UPDATE_STR_VIEW_TYPE, payload };
};

export const updateIsPiviotPresent = (payload) => {
    return { type: WATCHLIST?.UPDATE_IS_PIVIOT_PRESENT, payload };
};
export const updatedDashboardWatchlist = (payload) => {

    return { type: WATCHLIST.UPDATE_DASHBOARD_WATCHLIST, payload };
};

function isDifferentDate(timestamp) {
    const inputDate = new Date(timestamp);
    const currentDate = new Date();

    return (
        inputDate.getFullYear() !== currentDate.getFullYear() ||
        inputDate.getMonth() !== currentDate.getMonth() ||
        inputDate.getDate() !== currentDate.getDate()
    );
}

// Example

export const updateObjScripsAdditionalInfo = (payload) => {
    return { type: 'WAT_SCRIP_ADD_INFO', payload };
};

export const handleScripsAdditionalInfo = (arrPayload) => async (dispatch) => {
    try {
        let storedData = await createIndexedDBStorage().find('scripsAdditionalInfo');
        if (storedData && !isDifferentDate(JSON.parse(storedData)?.timeStamp)) {
            let objDataForAsked = {};
            let nonFilteredData = [];
            let parsedStoredData = JSON.parse(storedData)?.data;
            arrPayload.forEach(element => {
                //getMktSegIdFromApiExchangeName
                if (parsedStoredData[`${getMappedMktSegIdFromApiExchangeName(element.exchange)}_${element.scrip_token}`]) {
                    objDataForAsked[`${getMappedMktSegIdFromApiExchangeName(element.exchange)}_${element.scrip_token}`] = parsedStoredData[`${getMappedMktSegIdFromApiExchangeName(element.exchange)}_${element.scrip_token}`];
                } else {
                    nonFilteredData.push(element);
                }
            });
            if (nonFilteredData?.length > 0) {
                const objResp = await scripAdditionalinfo(nonFilteredData);
                let obj = { ...parsedStoredData };
                if (objResp?.data?.result?.length > 0) {
                    objResp?.data?.result?.forEach(element => {
                        obj[`${element.nMarketSegmentId}_${element.nToken}`] = element;
                        objDataForAsked[`${element.nMarketSegmentId}_${element.nToken}`] = element;
                    });
                }
                dispatch(updateObjScripsAdditionalInfo(obj));
                await createIndexedDBStorage().set('scripsAdditionalInfo', JSON.stringify({ timeStamp: Date.now(), data: obj }));
            }
            dispatch(updateObjScripsAdditionalInfo(objDataForAsked));
            return objDataForAsked;
        } else {
            const objResp = await scripAdditionalinfo(arrPayload);

            let obj = {};
            if (objResp?.data?.result?.length > 0) {
                objResp?.data?.result?.forEach(element => {
                    obj[`${element.nMarketSegmentId}_${element.nToken}`] = element;
                });
            }
            dispatch(updateObjScripsAdditionalInfo(obj));
            await createIndexedDBStorage().set('scripsAdditionalInfo', JSON.stringify({ timeStamp: Date.now(), data: obj }));
            return obj;
        }


    } catch (error) {
        console.error("Error in scripAdditionalinfo API ->", error.message);
        return error;
    }
};

export const getScripsAdditionalInfo = (arrPayload) => async (dispatch) => {
    try {
        const objResp = await scripAdditionalinfo(arrPayload);
        dispatch(getScripsAdditionalInfoSuccess(objResp?.data?.result));
    } catch (error) {
        dispatch(getScripsAdditionalInfoFailure([]));

    }
};
export const selectScripForDelete = (payload) => {

    return { type: WATCHLIST.SELECT_SCRIP_FOR_DELETE, payload: payload };
};
export const getScripsAdditionalInfoSuccess = (payload) => {
    return { type: WATCHLIST.GET_SCRIPS_ADDITIONAL_INFO_SUCCESS, payload: payload };
};
export const getScripsAdditionalInfoFailure = (payload) => {
    return { type: WATCHLIST.GET_SCRIPS_ADDITIONAL_INFO_FAILURE, payload: payload };
};


/*BT-109369 Breeze- Watchlist- Share Watchlist --start*/

export const openSharedWatchlistLink = () => async (dispatch, getState) => {
    const objWatchlistDetails = JSON.parse(getDecryptLocalStorage(DEEP_LINK));
    let objResp = await getDataByWatchlistId(objWatchlistDetails?.id);
    dispatch(getGlobalWatchlistScrips(objResp?.data?.data));
    dispatch(handleModal([{ 'GLOBAL_WATCHLIST_SCRIPT_MODAL': true }]));
};

/*BT-109369 Breeze- Watchlist- Share Watchlist --end  */

export const getFocusedCard = (payload) => {
    return { type: WATCHLIST.GET_FOCUS_CARD, payload: payload };
};


export const updateHoldingsWatchlist = (payload) => {
    return { type: WATCHLIST?.UPDATE_HOLDINGS_WATCHLIST, payload };
};

// Deepti b. BT-107398 [18/11/2024]: selected heatmap tile data
export const updateSelectedHeatmapTile = (payload) => {
    return { type: WATCHLIST?.UPDATE_SELECTED_HEATMAP_TILE_WATCHLIST, payload };
};

export const isPopoverOpen = (payload) => {
    return { type: WATCHLIST.IS_POPOVER_OPEN, payload };
};


export const updateDefaultManageColumnName = (payload) => async (dispatch, getState) => {
    dispatch(updateDefaultManageColumnNameSuccess(payload));
};

export const updateDefaultManageColumnNameSuccess = (payload) => {
    return { type: UPDATE_DEFAULT_MANAGE_COLUMN_NAME, payload };
};